import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

const ConsentNotice = () => (
  <div className="flex items-start gap-2 text-xs text-muted-foreground">
    <Lock className="w-3.5 h-3.5 shrink-0 mt-0.5 text-primary" />
    <p>
      By submitting this form, you authorize Mom&nbsp;&&nbsp;Pop Insurance Shop to contact you by phone, text message, or email regarding your inquiry. We <span className="font-semibold text-foreground">never sell your information</span> — you'll only hear from our licensed agents.{" "}
      <Link to="/privacy" className="underline hover:text-foreground transition-colors">Privacy Policy</Link>
    </p>
  </div>
);

export default ConsentNotice;
